import { gql, useLazyQuery } from '@apollo/client'
import { Select } from '@nextretreat/ui-components/dist/Select'
import { toast } from 'react-toastify'
import { IAmenity } from 'utils'
import { IVenueFormValues } from './FormPage'
import { useFormikContext } from 'formik'
import debounce from 'lodash.debounce'

const SEARCH_AMENITIES = gql`
  query SearchAmenities($search: String!) {
    searchAmenities(search: $search) {
      id
      name
    }
  }
`

export const AmenitiesSearch = () => {
  const { setFieldValue } = useFormikContext<IVenueFormValues>()

  const [searchAmenities] = useLazyQuery(SEARCH_AMENITIES)

  const loadOptions = async (
    inputValue: string,
    callback: (val: { label: string; value: string }[]) => void
  ) => {
    try {
      const res = await searchAmenities({ variables: { search: inputValue } })

      callback(
        res?.data?.searchAmenities?.map(({ id, name }: IAmenity) => ({
          label: name,
          value: id,
        }))
      )
      return res?.data?.searchAmenities?.map(({ id, name }: IAmenity) => ({
        label: name,
        value: id,
      }))
    } catch {
      toast.error('Error loading amenities')
    }
  }

  const debouncedLoadOptions = debounce(loadOptions, 500)

  return (
    <Select
      isAsync
      required
      isBlock
      cacheOptions
      loadOptions={debouncedLoadOptions}
      options={[]}
      label="Search for amenities"
      helpText="or select them from groups"
      onChange={({ value }) => {
        setFieldValue(`additionalInfo.amenities.${value}`, true)
      }}
      value={null}
    />
  )
}
